export default "__VITE_ASSET__QVb6iBil__"